import { render, staticRenderFns } from "./SinglePlay.vue?vue&type=template&id=55ac8c6f&scoped=true"
import script from "./SinglePlay.vue?vue&type=script&lang=js"
export * from "./SinglePlay.vue?vue&type=script&lang=js"
import style0 from "./SinglePlay.vue?vue&type=style&index=0&id=55ac8c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac8c6f",
  null
  
)

export default component.exports